import {
  AuctionState,
  ConsumerAuctionDTO,
  DealerAuctionDTO
} from "@/src/types/types";

/**
 * True when the same car is already listed again somewhere else — started, drafted,
 * or ended but still waiting on an offer. Such a re-listing supersedes the finished
 * auction, so actions that would reopen the old one (republish, extend negotiation)
 * are hidden.
 */
export const hasLiveAuctionWithSameRegno = (
  auctions: ConsumerAuctionDTO[] | undefined,
  excludeAuctionId: number | undefined,
  regNo: string | undefined | null
): boolean => {
  if (!auctions || !regNo) {
    return false;
  }
  return auctions.some(
    (auction) =>
      auction.id !== excludeAuctionId &&
      auction.auctionItem?.vehicle?.regNo?.toLowerCase() ===
        regNo.toLowerCase() &&
      (auction.auctionState === AuctionState.STARTED ||
        auction.auctionState === AuctionState.DRAFT ||
        (auction.auctionState === AuctionState.ENDED &&
          (!!auction.offerEndTime || !!auction.acceptedOffer)))
  );
};

export const filterHiddenAuctions = (
  auctions: DealerAuctionDTO[],
  showHiddenAuctions: boolean
): DealerAuctionDTO[] => {
  if (showHiddenAuctions) {
    return auctions;
  }
  return auctions.filter((auction) => !auction.isHidden);
};

export const hasHiddenAuctions = (auctions: DealerAuctionDTO[]): boolean =>
  auctions.some((auction) => auction.isHidden);

export const countHiddenAuctions = (auctions: DealerAuctionDTO[]): number =>
  auctions.filter((auction) => auction.isHidden).length;

/**
 * Normalizes auction id for wizard persistence when only numeric ids are valid.
 */
export const resolveAuctionId = (
  id: number | string | undefined | null
): number | undefined => {
  if (typeof id === "number") {
    return id;
  }
  return undefined;
};

/**
 * Builds a path with an optional query string (no nested template literals).
 */
export const pathnameWithOptionalQuery = (
  pathname: string,
  queryString: string
): string => (queryString.length > 0 ? pathname + "?" + queryString : pathname);
